import { RateQuote } from '../rate';

export class QuickQuoteResponse {
  rates: RateQuote[] = [];
  mileage?: number;

  constructor(opts?: Partial<QuickQuoteResponse>) {
    if (opts?.rates != null) {
      this.rates = opts.rates.map((val) => new RateQuote(val));
    }
    if (opts?.mileage != null) {
      this.mileage = opts.mileage;
    }
  }
}
